/**
 * HR "Coverage" hub — /hr/coverage.
 *
 * Tabs:
 *   • Thresholds       — per-team absence cap + min-present floor editors
 *                        (HrCoverageThresholdsPage, unchanged)
 *   • Change requests  — record + browse offline-approved capacity changes with
 *                        evidence + effectivity (CapacityRequestsTab), gated on
 *                        `flags.capacityChangeRequests`.
 */
import { HrAccessGuard } from '../../components/hr/HrAccessGuard'
import { TabbedHub, type HubTab } from '../hr-hub/TabbedHub'
import { HrCoverageThresholdsPage } from '../HrCoverageThresholdsPage'
import { CapacityHistoryTab } from './CapacityHistoryTab'
import { CapacityRequestsTab } from './CapacityRequestsTab'

const TABS: HubTab[] = [
  { key: 'thresholds', label: 'Thresholds', render: () => <HrCoverageThresholdsPage /> },
  {
    key: 'requests',
    label: 'Change requests',
    flag: 'capacityChangeRequests',
    render: () => <CapacityRequestsTab />,
  },
  {
    key: 'history',
    label: 'History',
    flag: 'capacityChangeRequests',
    render: () => <CapacityHistoryTab />,
  },
]

export function HrCoverageHub(): JSX.Element {
  return (
    <HrAccessGuard>
      <div className="page">
        <TabbedHub
          testIdPrefix="coverage"
          routePath="/hr/coverage"
          heroTitle="Coverage"
          tabs={TABS}
        />
      </div>
    </HrAccessGuard>
  )
}
